import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios, { AxiosError } from "axios";

export const fetchArtData = createAsyncThunk(
  "getartstyle",
  async (
    { formData, activeView }: { formData: FormData; activeView: string },
    { rejectWithValue },
  ) => {
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_API_URL}/getartstyle`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${import.meta.env.VITE_API_KEY}`,
          },
        },
      );

      return { data: response.data, activeView };
    } catch (error) {
      throw rejectWithValue((error as AxiosError)?.response?.data);
    }
  },
);

interface ArtState {
  loading: boolean;
  Front: any;
  Back: any;
  Left: any;
  Right: any;
  Neck: any;
  error: string;
}

const initialState: ArtState = {
  loading: false,
  Front: null,
  Back: null,
  Left: null,
  Right: null,
  Neck: null,
  error: "",
};

export const artSlice = createSlice({
  name: "art",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchArtData.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(fetchArtData.fulfilled, (state, action) => {
        state.loading = false;
        state.error = "";
        switch (action.meta.arg.activeView) {
          case "Front":
            state.Front = action.payload.data.front_parent_data[0];
            break;
          case "Back":
            state.Back = action.payload.data.back_parent_data[0];
            break;
          case "Left":
            state.Left = action.payload.data.left_parent_data[0];
            break;
          case "Right":
            state.Right = action.payload.data.right_parent_data[0];
            break;
          case "Neck":
            state.Neck = action.payload.data.neck_parent_data[0];
            break;
          default:
            break;
        }
      })
      .addCase(fetchArtData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch art data";
      });
  },
});

export default artSlice.reducer;
